import {
  Label,
  Textarea,
  RecordInterface,
} from '@components/common/Forms';

/** Props */
interface JobInterviewStagesProps {
  record: RecordInterface,
  textareaName?: string,
  label?: string,
  placeholder?: string,
  labelDescriptionClass?: string,
}

/**
 * @description Job Interview Stages component. To be used in a form.
 * - `record` - record function from useBjForm
 * - `textareaName` - name of the textarea; default is 'interviewStages'
 * - `label` - label for the input
 * - `placeholder` - placeholder for the input
 * - `labelDescriptionClass` - additional classes for the label description
 */
export const JobInterviewStages = (props: JobInterviewStagesProps) => {
  // Destructure props
  const {
    record,
    textareaName = 'interviewStages',
    label = '',
    placeholder = '',
    labelDescriptionClass = '',
  } = props;

  // Render
  // **************************
  return (
    <Label
      description={label}
      descriptionClass={labelDescriptionClass}
    >
      <Textarea
        placeholder={placeholder ?? ''}
        rows={3}
        // Safari does not support field-sizing; it will default to 3 rows
        className="[field-sizing:content]"
        {...record(textareaName)}
      />
    </Label>
  );
};
